import FormSelect from '@/components/UI/FormSelect';
import { DAILY_MICROTREND_FEATURE_SET, type OptimizerFeatureSetSelection, type OptimizerJobInput } from './jobConfigInput';

interface FeatureSetSelectProps {
    entityType: OptimizerJobInput['entityType'];
    value: OptimizerFeatureSetSelection;
    onChange: (value: OptimizerFeatureSetSelection) => void;
}

const FeatureSetSelect = ({ entityType, value, onChange }: FeatureSetSelectProps) => (
    <FormSelect
        helpText={
            entityType === 'Asset'
                ? "Daily microtrends require published daily data. Today's close is unavailable until its nightly publication."
                : 'Daily microtrends are available for equities and equity ETFs only.'
        }
        id="opt-feature-set"
        label="Feature Set"
        options={[
            { value: '', label: 'Standard features (default)' },
            ...(entityType === 'Asset' ? [{ value: DAILY_MICROTREND_FEATURE_SET, label: 'Daily microtrends (9 fields)' }] : [])
        ]}
        value={entityType === 'Asset' ? value : ''}
        onChange={(event) => onChange(event.target.value === DAILY_MICROTREND_FEATURE_SET ? DAILY_MICROTREND_FEATURE_SET : '')}
    />
);

export default FeatureSetSelect;
